import { render, staticRenderFns } from "./CustomWidthProperty.vue?vue&type=template&id=ce8a08d4&"
import script from "./CustomWidthProperty.vue?vue&type=script&lang=js&"
export * from "./CustomWidthProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports